import 'react';
import { Skeleton, Stack } from '@mui/material';

export const AdvancedDashboardFilters = () => {
  return (
    <Stack
      justifyContent={'start'}
      alignItems={{ xs: 'stretch', md: 'center' }}
      direction={{ xs: 'column', md: 'row' }}
      flexWrap={'wrap'}
      gap={1}
      sx={{ mb: 2.25 }}
    >
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '181.58px' } }} height={36.5} />
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '167.09px' } }} height={36.5} />
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '116.64px' } }} height={36.5} />
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '146.14px' } }} height={36.5} />
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '167.13px' } }} height={36.5} />
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '147.31px' } }} height={36.5} />
      <Skeleton variant="rounded" sx={{ width: { xs: '100%', md: '133.34px' } }} height={36.5} />
    </Stack>
  );
};
